import React, { useState, useRef, useEffect, useCallback } from 'react';
import classnames from 'classnames';
import { fromEvent } from 'rxjs';
import { throttleTime, share } from 'rxjs/operators';

import AlertStructuresInDescription from './AlertStructuresInDescription';
import AlertToggleButton from './AlertToggleButton';

import './AlertDescription.scss';

const resize$ = fromEvent(window, 'resize').pipe(throttleTime(300), share());

function AlertDescription(props) {
  const { description, showLabel, hideLabel } = props;
  const [open, setOpen] = useState(false);
  const [showToggleButton, setShowToggleButton] = useState(false);
  const wrapperRef = useRef(null);
  const descriptionRef = useRef(null);

  const toggle = useCallback(() => {
    setOpen((prevOpen) => !prevOpen);
  }, []);

  const calcToggleButton = useCallback(() => {
    if (descriptionRef.current) {
      const shouldShowToggleButton = descriptionRef.current.scrollWidth > descriptionRef.current.offsetWidth;
      setShowToggleButton(shouldShowToggleButton);
    }
  }, []);

  useEffect(() => {
    calcToggleButton();
    const resizeStream$ = resize$.subscribe(calcToggleButton);
    return () => {
      resizeStream$.unsubscribe();
    };
  }, [calcToggleButton]);

  return (
    <section
      ref={wrapperRef}
      className={classnames('alert-description alerts--second-line clearfix', {
        'alert-description--collapsed': !open,
        'alert-description--padding-for-toggle': !open && showToggleButton,
      })}>
      <div ref={descriptionRef} className={classnames('alert-description--content-wrapper')}>
        <p className={classnames('alert-description--text')}>{description}</p>
        <AlertStructuresInDescription {...props} />
      </div>
      {showToggleButton && <AlertToggleButton open={open} toggle={toggle} showLabel={showLabel} hideLabel={hideLabel} />}
    </section>
  );
}

export default AlertDescription;
